<template>
  <section class="hero is-small is-light my-hero" style="margin-bottom: 0; padding-bottom: 0;">
    <div class="hero-body">
      <div class="columns">
        <div class="column">
          <p class="title">
            <strong>{{ $config.APP }}</strong> | {{ $store.getters.USER.data['Наименование'] }}
          </p>
          <div class="subtitle">
            <Menu/>
            <strong v-if="observers && observers.length < 2 && observers.length !== 0">ДЕЖУРНЫЕ</strong>
            <div style="padding: 0; margin: 0" v-if="observers && observers.length < 2 && observers.length !== 0">
              <div class="menu-label" style="font-size: 10px; padding: 0; margin: 0" v-for="district in observers" :key="district">
                <p style="opacity: 0.3;" v-if="observers.length > 1">{{ district.district.name }}</p>
                <p v-if="district.observers.stobserver.guid">{{ initials(district.observers.stobserver.name) }} <span v-if="district.observers.stobserver.number"> ({{ district.observers.stobserver.number }})</span></p>
                <p v-if="district.observers.observer.guid">{{ initials(district.observers.observer.name) }} <span v-if="district.observers.observer.number"> ({{ district.observers.observer.number }})</span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-narrow" style="text-align: right; position: relative;">
          <div style="text-align: left">
            <div class="right-hero-element interactive" style="text-align: center">
              <span class="hero-text">
                <a :href="`${this.$config.SSL}://${this.$config.AUTH_ADDRESS}/`">
                  ВЫХОД <font-awesome-icon style="margin-left: 10px" icon="fa-solid fa-person-walking-dashed-line-arrow-right" />
                </a>
              </span>
            </div>
            <div class="right-hero-element menu-label has-text-right">
              <span v-if="$config.HERO.phone"><font-awesome-icon icon="fa-solid fa-phone-flip" />&nbsp;{{ $config.HERO.phone }}</span>&nbsp;<font-awesome-icon v-on:click="openModal()" :data-target="`modal-help`" icon="fa-regular fa-circle-question" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <template v-if="observers && observers.length > 1">
    <div class="box mini-header">
      <strong style="font-size: 12px">ДЕЖУРНЫЕ</strong>
      <div class="columns is-multiline" style="padding: 0; margin: 0">
        <div class="column is-3 menu-label" style="font-size: 10px; padding: 0; margin: 0" v-for="district in observers" :key="district">
          <p style="opacity: 0.3;" v-if="observers.length > 1">{{ district.district.name }}</p>
          <p v-if="district.observers.stobserver.guid">{{ initials(district.observers.stobserver.name) }} <span v-if="district.observers.stobserver.number"> ( {{ district.observers.stobserver.number }})</span></p>
          <p v-if="district.observers.observer.guid">{{ initials(district.observers.observer.name) }} <span v-if="district.observers.observer.number"> ( {{ district.observers.observer.number }})</span></p>
        </div>
      </div>
    </div>

  </template>
</template>

<script>
import Menu from "@/components/Menu";
import {initials} from "@/lib/utils";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Hero",
  async beforeMount() {
    await this.getObserversList()
  },
  components: {
    Menu
  },
  data() {
    return {
      observers: null
    }
  },
  props: ['type'],
  methods: {
    initials,
    getObserversList: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetObserversList`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            if (result !== "") {
              this.observers = JSON.parse(result)
            }
          })
    },
    toEIS: function () {
      window.location.replace(`${this.$config.SSL}://${this.$config.AUTH_ADDRESS}/`);
    },
    openModal: function () {
      let modal = document.getElementById(`modal-help`)
      if (!modal.classList.toString().includes('is-active')) {
        modal.classList.add('is-active')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.hero-icon {
  margin-right: 10px !important;
  color: rgb(45, 140, 0);
  transition: 0.3s;
}
.interactive {
  border-radius: 5px;
  padding: 2px;
  font-weight: bolder;
  border-bottom: 1px dotted rgb(45, 140, 0);
  transition: 0.3s;
}

.interactive:hover {
  padding: 2px;
  font-weight: bolder;
  border-bottom: 1px dotted rgb(140, 25, 0);
  .hero-icon {
    margin-right: 10px !important;
    color: rgb(140, 25, 0);
  }
}

.copy-icon {
  color: rgb(45, 140, 0);
}
.title {
  font-size: 14px !important;
}
.subtitle {
  font-size: 12px !important;
  margin-top: -20px !important;
}

.is-hidden-desktop {
  font-size: 14px !important;
  font-weight: bolder !important;
}
.has-text-left-touch {
  .title {
    font-size: 10px !important;
  }
}

.typing-demo {
  width: 24ch;
  animation: typing 2s steps(22), blink .5s step-end infinite alternate;
  white-space: nowrap;
  overflow: hidden;
  border-right: 3px solid;
  font-family: monospace;
  font-size: 2em;
}

@keyframes typing {
  from {
    width: 0
  }
}

@keyframes blink {
  50% {
    border-color: transparent
  }
}

.mini-header {
  border-radius: 0 !important;
  z-index: 20 !important;
  backdrop-filter: blur(10px) grayscale(1);
  background-color: transparent;
}

</style>
